<template>
  <div class="flex items-center justify-between p-3 bg-white rounded border border-green-200">
    <div class="flex items-center space-x-2">
      <div class="w-6 h-6 rounded flex items-center justify-center" :class="[`bg-${variant}-600`]">
        <font-awesome-icon :icon="['fas', icon]" class="text-white h-3" />
      </div>
      <div>
        <div class="font-medium text-sm">{{ LicenseType[id] }}</div>
        <div class="text-xs text-gray-600">
          {{ totalLicenses }} - {{ license_length }}
        </div>
      </div>
    </div>
    <div class="text-right">
      <div class="text-xs font-medium">{{ duration }}</div>
    </div>
  </div>
</template>

<script>
import { LicenseType } from '@/common/constants';
import { DateTime } from 'luxon';

export default {
  name: 'ActiveServiceCard',
  props: {
    id: String,
    quantity: Number,
    start_date: [DateTime, String],
    license_length: String,
    icon: String,
    variant: {
      type: String,
      default: 'gray', // e.g. 'gray', 'blue', 'yellow', 'red', etc.
    },
  },
  data: function() {
    return {
      LicenseType
    };
  },
  computed: {
    duration() {
      if(!this.start_date || !this.license_length) {
        return '';
      }
      let startDate = this.start_date;
      
      // Ensure start_date is a Luxon DateTime
      if (!DateTime.isDateTime(this.start_date)) {
        startDate = this.$dateTime.fromFormat(this.start_date, 'yyyy-MM-dd');
      }

      let endDate = startDate.plus({ months: this.license_length}).toFormat('dd/MM/yyyy');

      return startDate.toFormat('dd/MM/yyyy') + " - "  + endDate;
    },
    totalLicenses() {
      return this.$t('Company.LicensesNumber', parseInt(this.quantity, 10));
    }
  }
}
</script>